import {styled} from "@mui/material/styles"
import {Gradient} from "../../../Chevron/component"

const GradientClub = styled(Gradient, {
    shouldForwardProp: prop => !["templating"].includes(prop as string),
})`
    height: 100%;
    background: none;
`

export default GradientClub
